import { isAiSpendLimitCode } from "@productlane/lib"

export class AiChatRequestError extends Error {
	readonly code?: string

	constructor(message: string, code?: string) {
		super(message)
		this.name = "AiChatRequestError"
		this.code = code
	}
}

// The copilot answers a refusal with { code, message }. Keeping the code on the
// error is what lets the catch offer the fix without reading the copy.
export async function aiChatRequestError(
	response: Response,
	fallback: string,
): Promise<AiChatRequestError> {
	const body = response.ok
		? null
		: ((await response.json().catch(() => null)) as {
				message?: string
				code?: string
			} | null)
	return new AiChatRequestError(body?.message ?? fallback, body?.code)
}

export function isCapReachedError(error: unknown): boolean {
	return error instanceof AiChatRequestError && isAiSpendLimitCode(error.code)
}
